// extracted by mini-css-extract-plugin
export default {"btn_error":"SubUserDeleteForm_btn_error__FVS8U","btn_success":"SubUserDeleteForm_btn_success__t3Bgi"};